import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"

export const DialogStyles = makeStyles((theme: Theme) => createStyles({
	dialog: {
	},
	dialogroot: {
		'& h2': {
			display: "flex",
			justifyContent: "space-between",
			fontSize: theme.typography.h6.fontSize,
			color: theme.palette.common.black,
		}
	},
	dialogicon: {
		color: theme.palette.primary.main,
	},
	dialogTitle: {
		color: "rgba(0, 0, 0, 0.87)"
	},
	dialogPaper: {
		width: "100%",
	},
	dialogpaperScrollPaper: {
		width: "100%",
		borderRadius: "6px !important"
	},
	dialogPaperScrollBody: {

	},
	dialogActions: {
		padding: "8px 24px",
		"& button": {
			padding: "16px 0",
			fontSize: theme.typography.subtitle2.fontSize,
			lineHeight: 1,
		}
	},
	dialogContent: {
		fontSize: theme.typography.body2.fontSize,
		color: "rgba(0, 0, 0, 0.87)",
	},
	dialogCnt: {
		paddingTop: 0,
		paddingBottom: 0,
	}
}));